import React from 'react';
import { toast } from 'react-toastify';

/**
 * Consolidates multiple errors into a single toast notification.
 * @param {string|Array|Object} errorData - The error data from the backend.
 */
export const showErrorToast = (errorData) => {
    if (!errorData) return;

    let messages = [];

    if (typeof errorData === 'string') {
        messages = [errorData];
    } else if (Array.isArray(errorData)) {
        messages = errorData;
    } else if (typeof errorData === 'object') {
        // Flatten object values into a single array of strings
        messages = Object.values(errorData).flatMap(val =>
            Array.isArray(val) ? val : [val]
        );
    }

    if (messages.length > 0) {
        toast.error(
            <div>
                {messages.map((msg, index) => (
                    <div
                        key={index}
                        style={{
                            fontWeight: 600,
                            marginBottom: index !== messages.length - 1 ? '10px' : '0',
                            lineHeight: '1.4',
                            display: 'flex',
                            alignItems: 'flex-start'
                        }}
                    >
                        <span style={{ marginRight: '8px' }}>•</span>
                        <span>{msg}</span>
                    </div>
                ))}
            </div>,
            {
                autoClose: 5000,
                hideProgressBar: false,
            }
        );
    }
};
export const showSuccessToast = (message) => {
    toast.success(message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
};
